/* === FLYTEX THEME JS — Mobile-first === */
(function() {
  'use strict';

  // ---- Cart Drawer ----
  var cartDrawer = document.getElementById('cart-drawer');
  var cartOverlay = document.getElementById('cart-overlay');
  var cartClose = document.getElementById('cart-close');

  function openCart() {
    if (cartDrawer) { cartDrawer.classList.add('active'); cartDrawer.setAttribute('aria-hidden','false'); }
    if (cartOverlay) cartOverlay.classList.add('active');
    document.body.style.overflow = 'hidden';
  }
  function closeCart() {
    if (cartDrawer) { cartDrawer.classList.remove('active'); cartDrawer.setAttribute('aria-hidden','true'); }
    if (cartOverlay) cartOverlay.classList.remove('active');
    document.body.style.overflow = '';
  }

  document.querySelectorAll('[data-cart-open]').forEach(function(el) {
    el.addEventListener('click', function(e) { e.preventDefault(); openCart(); });
  });
  if (cartClose) cartClose.addEventListener('click', closeCart);
  if (cartOverlay) cartOverlay.addEventListener('click', function() { closeCart(); closeMobileMenu(); });

  // ---- Mobile Side Menu ----
  var mobileMenu = document.getElementById('mobile-menu');
  var mobileOverlay = document.getElementById('mobile-menu-overlay');
  var mobileToggle = document.getElementById('mobile-menu-toggle');
  var mobileClose = document.getElementById('mobile-menu-close');

  function openMobileMenu() {
    if (mobileMenu) { mobileMenu.classList.add('active'); mobileMenu.setAttribute('aria-hidden','false'); }
    if (mobileOverlay) mobileOverlay.classList.add('active');
    document.body.style.overflow = 'hidden';
  }
  function closeMobileMenu() {
    if (mobileMenu) { mobileMenu.classList.remove('active'); mobileMenu.setAttribute('aria-hidden','true'); }
    if (mobileOverlay) mobileOverlay.classList.remove('active');
    document.body.style.overflow = '';
  }

  if (mobileToggle) mobileToggle.addEventListener('click', openMobileMenu);
  if (mobileClose) mobileClose.addEventListener('click', closeMobileMenu);
  if (mobileOverlay) mobileOverlay.addEventListener('click', closeMobileMenu);

  // ---- FAQ toggle ----
  document.querySelectorAll('.faq-trigger').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var item = btn.closest('.faq-item');
      var isOpen = item.classList.contains('open');
      document.querySelectorAll('.faq-item.open').forEach(function(i) { i.classList.remove('open'); });
      if (!isOpen) item.classList.add('open');
    });
  });

  // ---- Add to cart via AJAX ----
  var productForm = document.getElementById('product-form');
  if (productForm) {
    productForm.addEventListener('submit', function(e) {
      e.preventDefault();
      var btn = productForm.querySelector('[type="submit"]');
      var variantId = document.getElementById('variant-id').value;
      if (!variantId) return;
      if (btn) { btn.disabled = true; btn.textContent = 'Ajout...'; }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: parseInt(variantId), quantity: 1 })
      })
      .then(function(r) { return r.json(); })
      .then(function() { return fetch('/cart.js'); })
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        updateCartCount(cart.item_count);
        updateCartDrawerTotal(cart.total_price);
        updateCartDrawerBody(cart);
        openCart();
        if (btn) { btn.disabled = false; btn.textContent = 'Ajouter au panier'; }
      })
      .catch(function(err) {
        console.error('Cart error:', err);
        if (btn) { btn.disabled = false; btn.textContent = 'Ajouter au panier'; }
      });
    });
  }

  function updateCartCount(count) {
    document.querySelectorAll('.js-cart-count, .cart-count').forEach(function(el) {
      el.textContent = count;
    });
    // Bottom nav badge
    var badge = document.querySelector('.mobile-bottom-nav__badge');
    if (badge) {
      badge.textContent = count;
      badge.style.display = count > 0 ? 'flex' : 'none';
    }
  }

  function updateCartDrawerTotal(cents) {
    var totalEl = document.getElementById('cart-drawer-total');
    if (totalEl) totalEl.textContent = formatMoney(cents);
  }

  function updateCartDrawerBody(cart) {
    var body = document.getElementById('cart-drawer-body');
    if (!body) return;
    if (cart.item_count === 0) {
      body.innerHTML = '<div class="cart-empty"><div class="cart-empty__icon">🛒</div><p class="cart-empty__text">Votre panier est vide</p><a href="/collections/all" class="btn btn--outline">Voir les produits</a></div>';
      return;
    }
    var html = '';
    cart.items.forEach(function(item) {
      html += '<div class="cart-item">';
      html += '<div class="cart-item__img"><img src="' + (item.image || '') + '" alt="' + item.title + '" loading="lazy"></div>';
      html += '<div class="cart-item__info">';
      html += '<div class="cart-item__name">' + item.product_title + '</div>';
      if (item.variant_title && item.variant_title !== 'Default Title') {
        html += '<div class="cart-item__variant">' + item.variant_title + '</div>';
      }
      html += '<div class="cart-item__price">' + formatMoney(item.price) + '</div>';
      html += '</div></div>';
    });
    body.innerHTML = html;
  }

  function formatMoney(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + '\u202f€';
  }

  // ---- Accordion (product page) ----
  window.toggleAccordion = function(btn) {
    var item = btn.closest('.accordion-item');
    var isOpen = item.classList.contains('open');
    document.querySelectorAll('.accordion-item.open').forEach(function(i) { i.classList.remove('open'); });
    if (!isOpen) item.classList.add('open');
  };

  // ---- Sticky header shadow on scroll ----
  var header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', function() {
      header.classList.toggle('scrolled', window.scrollY > 10);
    }, { passive: true });
  }

  // ---- Bottom nav active on scroll (optional) ----
  // already handled via Liquid template tags

  // ---- Swipe to close drawers (mobile) ----
  var touchStartX = 0;
  document.addEventListener('touchstart', function(e) { touchStartX = e.touches[0].clientX; }, { passive: true });
  document.addEventListener('touchend', function(e) {
    var dx = e.changedTouches[0].clientX - touchStartX;
    // Swipe right on cart drawer closes it
    if (dx > 80 && cartDrawer && cartDrawer.classList.contains('active')) closeCart();
    // Swipe left on mobile menu closes it
    if (dx < -80 && mobileMenu && mobileMenu.classList.contains('active')) closeMobileMenu();
  }, { passive: true });

})();